export default {
  '/zqhdapi/login': {
    data: { accessToken: 'zxczczczc' },
    success: true,
  },
  '/zqhdapi/role/delete': {
    data: null,
    success: true,
  },
  '/zqhdapi/menu/url/list': {
    data: {
      list: [
        {
          role: 'admin',
          menus: ['11', '34'],
        },
        {
          role: '普通角色',
          menus: ['11', '234'],
        },
      ],
      total: 99,
    },
    success: true,
  },
  '/api/osCard/list': {
    data: {
      records: [
        {
          role: 'admin',
          menus: ['11', '34'],
          cardList: [
            'data:image/png;base64,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',
          ],
        },
        {
          role: '普通角色',
          menus: ['11', '234'],
        },
      ],
      total: 99,
    },
    success: true,
  },
  '/api/cas/deleteUser': {
    data: null,
    success: true,
  },
  '/api/cas/getUserList': {
    data: {
      list: [
        {
          role: 'admin',
          menus: ['11', '34'],
        },
        {
          role: '普通角色',
          menus: ['11', '234'],
        },
      ],
      total: 99,
    },
    success: true,
  },
  '/zqhdapi/role/list': {
    data: {
      list: [
        {
          role: 'admin',
          menus: ['11', '34'],
        },
        {
          role: '普通角色',
          menus: ['11', '234'],
        },
      ],
      total: 99,
    },
    success: true,
  },
  '/zqhdapi/comp/list': {
    data: {
      list: [
        {
          compId: '111',
          compName: '比赛1',
          compDesc: '这是测试用的第一个比赛这是测试用的第一个比赛这是测试用的第一个比赛',
        },
        {
          compId: '222',
          compName: '比赛2',
          compDesc: '这是测试用的第二个比赛',
        },
        {
          compId: '333',
          compName: '比赛3',
          compDesc: '这是测试用的第三个比赛',
        },
      ],
      total: 99,
    },
    success: true,
  },
  '/zqhdapi/race/list': {
    data: {
      list: [
        {
          raceId: '1',
          raceName: '赛项1',
          raceDesc: '赛项1描述赛项1描述赛项1描述赛项1描述赛项1描述',
          compId: '111',
          compName: '比赛1',
          raceTime: ['2025-01-03 00:00:00', '2025-02-03 00:00:00'],
        },
        {
          raceId: '2',
          raceName: '赛项2',
          raceDesc: '赛项2描述赛项2描述赛项2描述赛项2描述赛项2描述',
          compId: '111',
          compName: '比赛1',
        },
        {
          raceId: '3',
          raceName: '赛项3',
          raceDesc: '赛项3描述赛项3描述赛项3描述赛项3描述赛项3描述',
          compId: '222',
          compName: '比赛2',
        },
      ],
      total: 99,
    },
    success: true,
  },
};
